import React from "react";
import { ChartsSetWrapper, ChartsSetWrapperNew, InfoCardNew, LogoLoader } from "../../../components";
import { dataSetup } from "./dataSetup";
import {
  buildDateReport,
  buildDateReportTotal,
} from "../../../dummydata/dataSet/dashbaordData";
import { asArray } from "../../../utils/common";
import { convertFromUTC, getZoneBasedOnLocaleInfo } from "../../../utils/dateUtils";
import dayjs from "dayjs";

const RA_METRIC_CONFIG = [
  { key: "accounts", label: "Accounts" },
  { key: "contacts", label: "Contacts" },
  { key: "jobOpenings", label: "Job Openings" },
  { key: "confirm", label: "Confirm" },
];

const BDM_METRIC_CONFIG = [
  { key: "positive", label: "Positive" },
  { key: "agreementDone", label: "Agreement Done" },
  { key: "internalSubmission", label: "Internal Submission" },
  { key: "clientSubmission", label: "Client Submission" },
  { key: "interviewScheduled", label: "Interview Scheduled" },
  { key: "joined", label: "Joined" },
  { key: "backout", label: "Backout" },
];

const RECRUITER_METRIC_CONFIG = [
  { key: "activeJobs", label: "Active Jobs" },
  { key: "internalSubmissions", label: "Internal Submission" },
  { key: "clientSubmissions", label: "Client Submission" },
  { key: "interviewScheduled", label: "Interview Scheduled" },
  { key: "closedJobs", label: "Closed Jobs" },
  { key: "joined", label: "Joined" },
];

// function getDateList(from, to) {
//   console.log("from,to",from,to)
//   const dates = [];
//   if (!from) return dates;

//   const current = new Date((from));
//   current.setHours(0, 0, 0, 0);

//   const end = to ? new Date(to) : new Date();
//   end.setHours(0, 0, 0, 0);

//   while (current <= end) {
//     dates.push(current.toISOString().split("T")[0]);
//     current.setDate(current.getDate() + 1);
//   }

//   return dates;
// }
export function getDateList(from, to) {
  if (!from) return [];

  const start = dayjs(from).startOf("day");
  const end = to
    ? dayjs(to).startOf("day")
    : dayjs().startOf("day");

  if (!start.isValid() || !end.isValid()) return [];

  const dates = [];
  let current = start;

  while (current.isSameOrBefore(end)) {
    dates.push(current.format("YYYY-MM-DD"));
    current = current.add(1, "day");
  }

  return dates;
}

// function buildTeamMetricsData({
//   teamMetrics = [],
//   reportToHierarchy = [],
//   from,
//   to,
//   metricConfig = []
// }) {
//   if (!from) return [];

//   const dates = [];
//   let current = new Date(from);
//   current.setHours(0, 0, 0, 0);

//   const end = to ? new Date(to) : new Date();
//   end.setHours(0, 0, 0, 0);

//   while (current <= end) {
//     dates.push(current.toISOString().slice(0, 10));
//     current.setDate(current.getDate() + 1);
//   }

//   const metricsByDate = {};
//   teamMetrics.forEach((item) => {
//     const dateKey = new Date(item.date).toISOString().slice(0, 10);
//     metricsByDate[dateKey] = item?.users || {};
//   });

//   const series = [];

//   reportToHierarchy.forEach((user) => {
//     const uiid = String(user.uiid);
//     const groupName = `${user.firstName} ${user.lastName}`;

//     metricConfig.forEach(({ key }) => {
//       const data = dates.map((date) => {
//         return metricsByDate[date]?.[uiid]?.[key] ?? 0;
//       });

//       series.push({
//         name: key,
//         data,
//         group: groupName
//       });
//     });
//   });

//   return series;
// }

function buildTeamMetricsData({
  teamMetrics = [],
  reportToHierarchy = [],
  from,
  to,
  metricConfig = [],
}) {
  const userTimezone = getZoneBasedOnLocaleInfo();
  if (!from) return [];

  const dates = [];
  let current = dayjs(from).startOf("day");
  const end = dayjs(to).startOf("day");

  while (current.isSameOrBefore(end)) {
    dates.push(current.format("YYYY-MM-DD"));
    current = current.add(1, "day");
  }

  const metricsByDate = Object.create(null);

  teamMetrics.forEach((item) => {
    if (!item?.date) return;

    const dateKey = dayjs
      .utc(item.date)        // backend UTC
      .tz(userTimezone)      // convert once
      .format("YYYY-MM-DD");

    metricsByDate[dateKey] = item.users || {};
  });


  const series = [];

  reportToHierarchy.forEach((user) => {
    const uiid = String(user.uiid);
    const groupName = `${user.firstName} ${user.lastName}`;

    metricConfig.forEach(({ key }) => {
      const data = dates.map(
        (date) => metricsByDate[date]?.[uiid]?.[key] ?? 0
      );

      series.push({
        name: key,
        data,
        group: groupName
      });
    });
  });

  return series;
}

const PerformanceReport = ({
  activeButton,
  finalDataDuration,
  metrics,
  teamMetrics,
  roleType,
  reportToHierarchy,
  loading
}) => {
  const metricsData =
    metrics?.length > 0
      ? roleType === 2 ?
         RA_METRIC_CONFIG.map(({ key, label }) => ({
            name: label,
            data: metrics.map(item => item[key] ?? 0),
          }))
        : roleType === 3 ? BDM_METRIC_CONFIG.map(({ key, label }) => ({
            name: label,
            data: metrics.map(item => item[key] ?? 0),
          }))
        : roleType === 4 ? RECRUITER_METRIC_CONFIG.map(({ key, label }) => ({
            name: label,
            data: metrics.map(item => item[key] ?? 0),
          }))
        : []
      : [];
  
  const teamMetricsData = activeButton !== "myPerformance" && 
    buildTeamMetricsData({
      teamMetrics: asArray(teamMetrics) , 
      reportToHierarchy: asArray(reportToHierarchy) , 
      from: finalDataDuration?.from, 
      to: finalDataDuration?.to, 
      metricConfig: roleType === 2 ? RA_METRIC_CONFIG : roleType === 3 ? BDM_METRIC_CONFIG : roleType === 4 ? RECRUITER_METRIC_CONFIG : []
    })

  const performanceReportDetails = activeButton === "myPerformance" ? metricsData : teamMetricsData

  const shouldShowLoader =
    loading &&
    (
      (activeButton === "myPerformance" && !metrics) ||
      (activeButton === "myTeamPerformance" && !teamMetrics)
    );

  if (shouldShowLoader) {
    return (
      <div className="flex justify-center items-center h-50">
        <LogoLoader />
      </div>
    );
  }

  return (
    <div>
      <div>
        <ChartsSetWrapperNew
          title="Performance Report"
          type="column"
          data={performanceReportDetails}
          categories={getDateList(convertFromUTC(finalDataDuration?.from), convertFromUTC(finalDataDuration?.to))}
          options={{
            padding: { left: 40 },
            grid: {
              color: "#ccc",
              dasharray: "3 3",
              strokeWidth: 0.5,
              horizontal: true,
              vertical: true,
              background: "#f9f9f9",
            },
            axis: {
              y: {
                clampMinZero: true,
              },
              x: {
                scroll: {
                  enabled: true,
                },
              },
            },
            bar: {
              fixedWidth: 30,
              gap: activeButton === "myTeamPerformance" ? 40 : 5,
              radius: 0,
              groupGap: activeButton === "myTeamPerformance" ? 5 : 40,
              stacked: activeButton === "myTeamPerformance",
              grouped: activeButton === "myTeamPerformance",
            },
          }}
        />
      </div>
    </div>
  );
};

export default PerformanceReport;
